<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Configuración</p>
    </div>
  </div>

  <div class="px-4 container-fluid pb-6">
    <div class="cfg-page-header mb-4">
      <h4 class="cfg-page-title">Configuración del sistema</h4>
      <p class="cfg-page-sub">Parámetros globales de Quanty — integraciones, bots y comunicaciones</p>
    </div>

    <Form role="form" class="text-start" @submit="handleConfiguracion">

      <!-- BOT -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">🤖</span>
          <div>
            <h6 class="cfg-section-title">Bot de Telegram</h6>
            <p class="cfg-section-desc">Token y nombre del bot principal que gestiona los canales</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-5">
              <soft-field id="bot" type="text" :useLabel="true" label="Nombre del bot" name="bot" v-model="user.bot" class="label-input" largo="50"/>
            </div>
            <div class="col-12 col-md-7">
              <soft-field id="tokenBot" type="password" :useLabel="true" label="Token" name="tokenBot" v-model="user.tokenBot" class="label-input" largo="150"/>
            </div>
          </div>
          <div class="cfg-toggle-row mt-3">
            <QToggle id="canales-switch" v-model="user.mostrarCanales" />
            <span class="cfg-toggle-label">{{ user.mostrarCanales
              ? 'Rastreo de canales activado — se reciben comandos del bot y peticiones de acceso' + (rastreoTelegram ? ' · Último rastreo: ' + rastreoTelegram : '')
              : 'Rastreo de canales desactivado — el bot no recibirá comandos ni gestionará accesos' }}</span>
          </div>
        </div>
      </div>

      <!-- TDLIB -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">⚡</span>
          <div>
            <h6 class="cfg-section-title">API TdLib</h6>
            <p class="cfg-section-desc">Credenciales para la cuenta de usuario de Telegram (bot premium)</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <soft-field id="apiId" type="text" :useLabel="true" label="API ID" name="apiId" v-model="user.apiId" class="label-input" largo="50"/>
            </div>
            <div class="col-12 col-md-8">
              <soft-field id="apiHash" type="password" :useLabel="true" label="API Hash" name="apiHash" v-model="user.apiHash" class="label-input" largo="150"/>
            </div>
          </div>
        </div>
      </div>

      <!-- TELÉFONO -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">📱</span>
          <div>
            <h6 class="cfg-section-title">Teléfono móvil de Quanty</h6>
            <p class="cfg-section-desc">Desde este número se envían los códigos de validación TdLib. Escribe el código cuando llegue al móvil.</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <soft-field id="movilQuanty" type="text" :useLabel="true" label="Teléfono (sin +)" name="movilQuanty" v-model="user.movilQuanty" class="label-input" largo="50"/>
            </div>
          </div>
          <div class="cfg-toggle-row mt-3">
            <QToggle id="lanza-switch" v-model="lanzadaValidacion" :disabled="lanzadaValidacion" @change="lanzarValidacion" />
            <label class="cfg-toggle-label mb-0">Lanzar el proceso de validación</label>
          </div>
          <div v-if="loadingValidacion" class="cfg-info-row mt-2">
            <span class="spinner-border spinner-border-sm me-2"></span>
            <span>Proceso en curso — introduce el código cuando lo recibas en el móvil y pulsa Confirmar</span>
          </div>
          <div class="row g-3 mt-1" v-if="!user.validadoQuanty && lanzadaValidacion">
            <div class="col-12 col-md-3">
              <soft-field id="codeQuanty" type="text" :useLabel="true" label="Código de validación" name="codeQuanty" v-model="user.codeQuanty" class="label-input" largo="10"/>
            </div>
          </div>
        </div>
      </div>

      <!-- STRIPE -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">💳</span>
          <div>
            <h6 class="cfg-section-title">Stripe</h6>
            <p class="cfg-section-desc">Pasarela de pagos global — claves, webhooks y comisiones por defecto</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <soft-field id="stripe_secret_key" type="password" :useLabel="true" label="Secret Key" name="stripe_secret_key" v-model="user.stripe_secret_key" class="label-input" largo="200"/>
              <small class="cfg-hint">Clave secreta global de Quanty</small>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="stripe_webhook_secret" type="password" :useLabel="true" label="Webhook Secret" name="stripe_webhook_secret" v-model="user.stripe_webhook_secret" class="label-input" largo="200"/>
            </div>
            <div class="col-12 col-md-4">
              <soft-field id="comision_porcentaje" type="number" :useLabel="true" label="Comisión % defecto" name="comision_porcentaje" v-model="user.comision_porcentaje" class="label-input" largo="10"/>
              <small class="cfg-hint">Se aplica a tipsters sin % propio configurado</small>
            </div>
          </div>
          <div class="cfg-toggle-row mt-3">
            <QToggle id="stripe-payment-element-switch" v-model="user.stripe_payment_element_enabled" />
            <div>
              <span class="cfg-toggle-label">Google Pay / Apple Pay / Link (PaymentElement)</span>
              <small class="cfg-hint d-block">Activa el formulario unificado con soporte para tarjeta, Google Pay, Apple Pay y Link. Desactiva para usar el formulario clásico de campos separados.</small>
            </div>
          </div>
        </div>
      </div>

      <!-- META -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">📊</span>
          <div>
            <h6 class="cfg-section-title">Meta (Facebook)</h6>
            <p class="cfg-section-desc">Pixel, CAPI y Marketing API para atribución y análisis de campañas</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-4">
              <soft-field id="meta_pixel_id" type="text" :useLabel="true" label="Pixel ID" name="meta_pixel_id" v-model="user.meta_pixel_id" class="label-input" largo="50"/>
              <small class="cfg-hint">ID numérico — se aplica a todas las landing pages</small>
            </div>
            <div class="col-12 col-md-4">
              <soft-field id="meta_app_id" type="text" :useLabel="true" label="App ID" name="meta_app_id" v-model="user.meta_app_id" class="label-input" largo="50"/>
            </div>
            <div class="col-12 col-md-4">
              <soft-field id="meta_ad_account_id" type="text" :useLabel="true" label="Ad Account ID" name="meta_ad_account_id" v-model="user.meta_ad_account_id" class="label-input" largo="50"/>
              <small class="cfg-hint">Formato: act_XXXXXXXXX</small>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="meta_capi_token" type="password" :useLabel="true" label="CAPI Access Token" name="meta_capi_token" v-model="user.meta_capi_token" class="label-input" largo="500"/>
              <small class="cfg-hint">Token de acceso para la Conversions API (servidor a servidor)</small>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="meta_marketing_token" type="password" :useLabel="true" label="Marketing API Token" name="meta_marketing_token" v-model="user.meta_marketing_token" class="label-input" largo="500"/>
              <small class="cfg-hint">Para consultar campañas e insights desde la Marketing API</small>
            </div>
            <div class="col-12 col-md-4">
              <soft-field id="meta_test_event_code" type="text" :useLabel="true" label="Test Event Code" name="meta_test_event_code" v-model="user.meta_test_event_code" class="label-input" largo="50"/>
              <small class="cfg-hint">Solo para pruebas de CAPI — vacío en producción</small>
            </div>
          </div>
        </div>
      </div>

      <!-- GOOGLE ANALYTICS / GTM -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">📊</span>
          <div>
            <h6 class="cfg-section-title">Google Analytics</h6>
            <p class="cfg-section-desc">GTM y GA4 para analítica web. Se cargan dinámicamente sin necesidad de rebuild.</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-6">
              <soft-field id="gtm_id" type="text" :useLabel="true" label="GTM ID" name="gtm_id" v-model="user.gtm_id" class="label-input" largo="50"/>
              <small class="cfg-hint">Formato: GTM-XXXXXXX — Google Tag Manager</small>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="ga4_id" type="text" :useLabel="true" label="GA4 Measurement ID" name="ga4_id" v-model="user.ga4_id" class="label-input" largo="50"/>
              <small class="cfg-hint">Formato: G-XXXXXXXXXX — Google Analytics 4</small>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="ga4_api_secret" type="password" :useLabel="true" label="GA4 API Secret (server-side)" name="ga4_api_secret" v-model="user.ga4_api_secret" class="label-input" largo="50"/>
              <small class="cfg-hint">GA4 Admin → Data Streams → Measurement Protocol → Crear secreto. Necesario para trackear compras desde el servidor.</small>
            </div>
          </div>
          <div class="mt-3 d-flex align-items-center gap-3 flex-wrap">
            <button class="sync-btn sync-btn--ghost" @click="probarConfigGtm" :disabled="gtmProbando">
              <i :class="gtmProbando ? 'fa fa-spinner fa-spin' : 'fa fa-plug'"></i>
              {{ gtmProbando ? 'Verificando...' : 'Probar configuración' }}
            </button>
            <span v-if="gtmResultado" :class="gtmResultado.ok ? 'badge-ok' : 'badge-err'">
              {{ gtmResultado.msg }}
            </span>
          </div>
        </div>
      </div>

      <!-- OPENAI -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">🧠</span>
          <div>
            <h6 class="cfg-section-title">OpenAI</h6>
            <p class="cfg-section-desc">Clave de API para funcionalidades de inteligencia artificial</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-7">
              <soft-field id="openai_api_key" type="password" :useLabel="true" label="API Key" name="openai_api_key" v-model="user.openai_api_key" class="label-input" largo="200"/>
            </div>
          </div>
        </div>
      </div>

      <!-- BOT PREMIUM -->
      <div class="cfg-section">
        <div class="cfg-section-hd">
          <span class="cfg-icon">⭐</span>
          <div>
            <h6 class="cfg-section-title">Telegram Bot Premium</h6>
            <p class="cfg-section-desc">Token del bot secundario que gestiona canales de pago vía TdLib</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-7">
              <soft-field id="telegram_bot_premium_token" type="password" :useLabel="true" label="Token" name="telegram_bot_premium_token" v-model="user.telegram_bot_premium_token" class="label-input" largo="200"/>
            </div>
          </div>
        </div>
      </div>

      <!-- SMTP -->
      <div class="cfg-section cfg-section--last">
        <div class="cfg-section-hd">
          <span class="cfg-icon">✉️</span>
          <div>
            <h6 class="cfg-section-title">Correo (SMTP)</h6>
            <p class="cfg-section-desc">Servidor de envío de correos transaccionales y de contacto</p>
          </div>
        </div>
        <div class="cfg-section-bd">
          <div class="row g-3">
            <div class="col-12 col-md-5">
              <soft-field id="mail_host" type="text" :useLabel="true" label="Host SMTP" name="mail_host" v-model="user.mail_host" class="label-input" largo="100"/>
            </div>
            <div class="col-12 col-md-3">
              <soft-field id="mail_port" type="text" :useLabel="true" label="Puerto" name="mail_port" v-model="user.mail_port" class="label-input" largo="10"/>
            </div>
            <div class="col-12 col-md-4">
              <soft-field id="mail_encryption" type="text" :useLabel="true" label="Cifrado (tls/ssl)" name="mail_encryption" v-model="user.mail_encryption" class="label-input" largo="10"/>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="mail_username" type="text" :useLabel="true" label="Usuario" name="mail_username" v-model="user.mail_username" class="label-input" largo="100"/>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="mail_password" type="password" :useLabel="true" label="Contraseña" name="mail_password" v-model="user.mail_password" class="label-input" largo="100"/>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="mail_from_address" type="text" :useLabel="true" label="Dirección remitente" name="mail_from_address" v-model="user.mail_from_address" class="label-input" largo="100"/>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="mail_from_name" type="text" :useLabel="true" label="Nombre remitente" name="mail_from_name" v-model="user.mail_from_name" class="label-input" largo="100"/>
            </div>
            <div class="col-12 col-md-6">
              <soft-field id="mail_contact_to" type="text" :useLabel="true" label="Email de contacto" name="mail_contact_to" v-model="user.mail_contact_to" class="label-input" largo="100"/>
            </div>
          </div>
        </div>
      </div>

      <!-- ACCIONES -->
      <div class="cfg-actions mt-4">
        <QBtn
          type="button"
          variant="cancela"
          class="cfg-btn"
          :label="loadingReset ? '' : 'Reiniciar configuración'"
          :loading="loadingReset"
          :disabled="loadingReset"
          @click="confirmarReset"
        />
        <QBtn
          type="submit"
          variant="tipster"
          class="cfg-btn"
          :label="loading ? '' : 'Guardar configuración'"
          :loading="loading"
          :disabled="loading"
        />
      </div>

    </Form>

    <!-- Herramientas de sistema — solo superadmin -->
    <div v-if="miRol === 1" class="cfg-section cfg-section--tools mt-3">
      <div class="cfg-section-hd">
        <span class="cfg-icon">🗄️</span>
        <div>
          <h6 class="cfg-section-title">Herramientas de sistema</h6>
          <p class="cfg-section-desc">Operaciones avanzadas de mantenimiento</p>
        </div>
      </div>
      <div class="cfg-section-bd">
        <div class="d-flex align-items-center gap-3 flex-wrap">
          <div>
            <p class="cfg-tool-label">Backup de base de datos</p>
            <p class="cfg-tool-desc">Genera un volcado SQL completo y lo descarga directamente. El archivo queda guardado también en el servidor.</p>
          </div>
          <QBtn
            type="button"
            variant="tipster"
            class="cfg-btn flex-shrink-0"
            :label="loadingBackup ? '' : 'Descargar backup'"
            :loading="loadingBackup"
            :disabled="loadingBackup"
            @click="generarBackup"
          />
        </div>
      </div>
    </div>

    <!-- Sincronizar desde Producción — solo superadmin, solo si el backend lo permite (no prod) -->
    <div v-if="miRol === 1 && syncDisponible" class="cfg-section cfg-section--sync mt-3">
      <div class="cfg-section-hd">
        <span class="cfg-icon">🔄</span>
        <div>
          <h6 class="cfg-section-title">Sincronizar desde Producción</h6>
          <p class="cfg-section-desc">Importa datos de prod que no existen en este entorno. Solo lectura en producción — nunca escribe nada allí.</p>
        </div>
        <span class="sync-dev-badge">SOLO DEV</span>
      </div>

      <div class="cfg-section-bd">

        <!-- Credenciales -->
        <div class="sync-cred-block">
          <div class="sync-cred-header" @click="syncMostrarCred = !syncMostrarCred">
            <span class="sync-cred-title">
              <i :class="syncConectado ? 'fa fa-check-circle sync-icon-ok' : 'fa fa-plug sync-icon-warn'"></i>
              {{ syncConectado
                ? ('Conectado a producción' + (syncUsaSsh ? ' · vía túnel SSH' : ''))
                : 'Configura las credenciales de la BD de producción' }}
            </span>
            <i :class="syncMostrarCred ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" class="sync-cred-toggle"></i>
          </div>

          <div v-if="syncMostrarCred" class="sync-cred-form">

            <!-- Toggle SSH -->
            <div class="sync-ssh-toggle mb-3">
              <label class="sync-ssh-toggle-label">
                <input type="checkbox" v-model="syncCred.usar_ssh" class="sync-check">
                Usar túnel SSH
                <span class="sync-badge-info">Necesario si MySQL solo escucha en localhost del servidor</span>
              </label>
            </div>

            <!-- Campos SSH (solo si está activado) -->
            <template v-if="syncCred.usar_ssh">
              <p class="sync-ssh-hint">
                El backend abre un túnel SSH al servidor de producción y se conecta a MySQL a través de él.
                Requiere que la clave SSH indicada esté autorizada en el servidor de prod.
              </p>
              <div class="row g-2 mb-2">
                <div class="col-12 col-md-5">
                  <label class="sync-label">Host SSH (IP prod)</label>
                  <input type="text" class="sync-input" v-model="syncCred.ssh_host" placeholder="217.154.178.3">
                </div>
                <div class="col-12 col-md-2">
                  <label class="sync-label">Puerto SSH</label>
                  <input type="text" class="sync-input" v-model="syncCred.ssh_port" placeholder="22">
                </div>
                <div class="col-12 col-md-5">
                  <label class="sync-label">Usuario SSH</label>
                  <input type="text" class="sync-input" v-model="syncCred.ssh_user" placeholder="root">
                </div>
              </div>
              <div class="row g-2 mb-3">
                <div class="col-12">
                  <label class="sync-label">Ruta de la clave privada SSH (en el servidor dev)</label>
                  <input type="text" class="sync-input" v-model="syncCred.ssh_key" placeholder="/home/quantydev/.ssh/id_prod">
                </div>
              </div>
              <div class="sync-ssh-steps mb-3">
                <p class="sync-ssh-steps-title">Configuración previa (solo la primera vez):</p>
                <pre class="sync-ssh-pre">ssh-keygen -t ed25519 -f /home/quantydev/.ssh/id_prod -N ""
ssh-copy-id -i /home/quantydev/.ssh/id_prod.pub root@217.154.178.3</pre>
              </div>
              <hr class="sync-sep mb-3">
            </template>

            <!-- Credenciales BD -->
            <div class="row g-2 mb-2">
              <div class="col-12 col-md-5">
                <label class="sync-label">{{ syncCred.usar_ssh ? 'Host BD (en prod, normalmente 127.0.0.1)' : 'Host BD' }}</label>
                <input type="text" class="sync-input" v-model="syncCred.host"
                  :placeholder="syncCred.usar_ssh ? '127.0.0.1' : 'db.miservidor.com'">
              </div>
              <div class="col-12 col-md-2">
                <label class="sync-label">Puerto BD</label>
                <input type="text" class="sync-input" v-model="syncCred.port" placeholder="3306">
              </div>
              <div class="col-12 col-md-5">
                <label class="sync-label">Base de datos</label>
                <input type="text" class="sync-input" v-model="syncCred.database" placeholder="quanty_prod">
              </div>
            </div>
            <div class="row g-2 mb-3">
              <div class="col-12 col-md-6">
                <label class="sync-label">Usuario BD</label>
                <input type="text" class="sync-input" v-model="syncCred.username" placeholder="db_user">
              </div>
              <div class="col-12 col-md-6">
                <label class="sync-label">Contraseña BD</label>
                <input type="password" class="sync-input" v-model="syncCred.password" placeholder="••••••••">
              </div>
            </div>

            <button class="sync-btn sync-btn--primary" @click="guardarCredencialesProd" :disabled="syncGuardandoCred">
              <i :class="syncGuardandoCred ? 'fa fa-spinner fa-spin' : 'fa fa-save'"></i>
              {{ syncGuardandoCred ? 'Probando conexión...' : 'Guardar y probar conexión' }}
            </button>
          </div>
        </div>

        <!-- Tabla de comparación -->
        <template v-if="syncConectado">
          <div class="sync-table-toolbar">
            <span class="sync-table-info">
              {{ syncTablas.length }} tablas · {{ syncTotalFaltantes }} filas nuevas disponibles
            </span>
            <div class="sync-table-actions">
              <button class="sync-btn sync-btn--ghost" @click="syncSeleccionarTodas">Todas con datos nuevos</button>
              <button class="sync-btn sync-btn--ghost" @click="syncSeleccionadas = []">Ninguna</button>
              <button class="sync-btn sync-btn--primary" @click="cargarEstadoSync" :disabled="syncCargando">
                <i :class="syncCargando ? 'fa fa-spinner fa-spin' : 'fa fa-refresh'"></i>
                Actualizar
              </button>
            </div>
          </div>

          <div class="sync-table-wrap">
            <table class="sync-table">
              <thead>
                <tr>
                  <th class="sync-th sync-th--check"></th>
                  <th class="sync-th sync-th--name">Tabla</th>
                  <th class="sync-th sync-th--num">En prod</th>
                  <th class="sync-th sync-th--num">En dev</th>
                  <th class="sync-th sync-th--num">Filas nuevas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in syncTablas" :key="t.tabla"
                    class="sync-tr"
                    :class="{ 'sync-tr--sel': syncSeleccionadas.includes(t.tabla), 'sync-tr--err': t.error }">
                  <td class="sync-td sync-td--check">
                    <input type="checkbox"
                      class="sync-check"
                      :value="t.tabla"
                      v-model="syncSeleccionadas"
                      :disabled="!t.has_id || t.error || t.faltantes === 0">
                  </td>
                  <td class="sync-td sync-td--name">
                    {{ t.tabla }}
                    <span v-if="t.error" class="sync-badge-err" :title="t.error">Error</span>
                    <span v-else-if="!t.has_id" class="sync-badge-info">sin id</span>
                  </td>
                  <td class="sync-td sync-td--num">{{ t.prod ?? '—' }}</td>
                  <td class="sync-td sync-td--num">{{ t.dev ?? '—' }}</td>
                  <td class="sync-td sync-td--num">
                    <span v-if="t.faltantes > 0" class="sync-badge-new">+{{ t.faltantes }}</span>
                    <span v-else-if="t.faltantes === 0" class="sync-badge-ok">Al día</span>
                    <span v-else>—</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="sync-import-bar">
            <span class="sync-sel-info">
              {{ syncSeleccionadas.length }} tabla(s) seleccionada(s)
            </span>
            <button class="sync-btn sync-btn--import"
              @click="importarDesdeProd"
              :disabled="syncImportando || syncLimpiando || !syncSeleccionadas.length">
              <i :class="syncImportando ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
              {{ syncImportando ? 'Importando...' : `Importar seleccionadas (${syncSeleccionadas.length})` }}
            </button>
            <button class="sync-btn sync-btn--limpiar"
              @click="limpiarDesarrollo"
              :disabled="syncImportando || syncLimpiando">
              <i :class="syncLimpiando ? 'fa fa-spinner fa-spin' : 'fa fa-trash-alt'"></i>
              {{ syncLimpiando ? 'Limpiando...' : 'Limpiar Desarrollo' }}
            </button>
          </div>
        </template>

        <!-- Resultado de importación -->
        <div v-if="syncResultado" class="sync-resultado">
          <p class="sync-resultado-titulo">
            <i class="fa fa-check-circle sync-icon-ok"></i>
            Importación completada — {{ syncResultado.total_insertados }} filas insertadas
          </p>
          <div class="sync-resultado-tabla-wrap">
            <table class="sync-table sync-table--sm">
              <thead>
                <tr>
                  <th class="sync-th sync-th--name">Tabla</th>
                  <th class="sync-th sync-th--num">Insertadas</th>
                  <th class="sync-th">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in syncResultado.resumen" :key="k" class="sync-tr">
                  <td class="sync-td sync-td--name">{{ k }}</td>
                  <td class="sync-td sync-td--num">{{ v.ok ? v.insertados : '—' }}</td>
                  <td class="sync-td">
                    <span v-if="v.ok" class="sync-badge-ok">OK</span>
                    <span v-else class="sync-badge-err" :title="v.msg">Error</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <!-- Logs de Producción — solo superadmin -->
    <div v-if="miRol === 1 && esDev" class="cfg-section cfg-section--logs mt-3">
      <div class="cfg-section-hd">
        <span class="cfg-icon">📋</span>
        <div>
          <h6 class="cfg-section-title">Logs de Producción</h6>
          <p class="cfg-section-desc">Consulta los logs del servidor de producción sin SSH.</p>
        </div>
      </div>

      <div class="cfg-section-bd">
        <div class="row g-2 mb-2">
          <div class="col-12 col-md-7">
            <label class="sync-label">URL base de producción</label>
            <input type="text" class="sync-input" v-model="logsProdUrl" placeholder="https://api.quanty.es">
          </div>
          <div class="col-12 col-md-5">
            <label class="sync-label">Token de API (superadmin prod)</label>
            <input type="password" class="sync-input" v-model="logsProdToken" placeholder="token superadmin prod">
          </div>
        </div>

        <div class="d-flex gap-2 flex-wrap mb-3">
          <button class="sync-btn sync-btn--primary" @click="logsCargarLista" :disabled="logsCargando || !logsProdUrl || !logsProdToken">
            <i :class="logsCargando ? 'fa fa-spinner fa-spin' : 'fa fa-list'"></i>
            {{ logsCargando ? 'Cargando...' : 'Ver lista de logs' }}
          </button>
          <button v-if="logsArchivoActual" class="sync-btn sync-btn--ghost" @click="logsArchivoActual = null; logsContenido = null">
            &laquo; Volver a la lista
          </button>
        </div>

        <!-- Lista de archivos -->
        <template v-if="logsArchivos.length && !logsArchivoActual">
          <div class="sync-table-wrap">
            <table class="sync-table">
              <thead>
                <tr>
                  <th class="sync-th sync-th--name">Archivo</th>
                  <th class="sync-th sync-th--num">Tamaño (KB)</th>
                  <th class="sync-th"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in logsArchivos" :key="a.archivo" class="sync-tr">
                  <td class="sync-td sync-td--name">{{ a.fecha }}</td>
                  <td class="sync-td sync-td--num">{{ a.tamano }} KB</td>
                  <td class="sync-td">
                    <button class="sync-btn sync-btn--ghost" style="padding:2px 10px;font-size:12px;"
                      @click="logsVerArchivo(a.archivo)" :disabled="logsCargandoContenido">
                      <i :class="logsCargandoContenido ? 'fa fa-spinner fa-spin' : 'fa fa-eye'"></i>
                      Ver
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <!-- Visor de contenido -->
        <template v-if="logsArchivoActual && logsContenido !== null">
          <div class="logs-viewer-header">
            <span class="logs-viewer-titulo">{{ logsArchivoActual }}</span>
            <span class="logs-viewer-meta" v-if="logsTotalLineas">{{ logsTotalLineas }} líneas totales (mostrando últimas {{ logsContenido.split('\n').length }})</span>
            <button class="sync-btn sync-btn--ghost" style="margin-left:auto;font-size:12px;" @click="logsGuardarLocal" :disabled="logsGuardando">
              <i :class="logsGuardando ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
              {{ logsGuardando ? 'Guardando...' : 'Guardar en servidor' }}
            </button>
          </div>
          <div class="logs-viewer-wrap">
            <pre class="logs-viewer-pre">{{ logsContenido }}</pre>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import SoftField from "@/components/SoftField.vue";
import { globalFunctionsMixin } from '@/mixins/globalFunctions.js';
import { Form } from "vee-validate";

export default {
  name: "Configuracion",
  components: { SoftField, Form },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      loading: false,
      loadingValidacion: false,
      loadingReset: false,
      loadingBackup: false,
      user: {
        bot: '',
        tokenBot: '',
        apiId: '',
        apiHash: '',
        mostrarCanales: false,
        movilQuanty: '',
        codeQuanty: '',
        validadoQuanty: false,
        stripe_secret_key: '',
        stripe_webhook_secret: '',
        stripe_payment_element_enabled: false,
        comision_porcentaje: '',
        meta_pixel_id: '',
        meta_app_id: '',
        meta_ad_account_id: '',
        meta_test_event_code: '',
        gtm_id: '',
        ga4_id: '',
        ga4_api_secret: '',
        meta_capi_token: '',
        meta_marketing_token: '',
        openai_api_key: '',
        telegram_bot_premium_token: '',
        mail_host: '',
        mail_port: '',
        mail_username: '',
        mail_password: '',
        mail_encryption: '',
        mail_from_address: '',
        mail_from_name: '',
        mail_contact_to: '',
      },
      rastreoTelegram: '',
      lanzadaValidacion: false,
      // Sync desde prod
      gtmProbando: false,
      gtmResultado: null,
      syncDisponible: false,
      syncConectado: false,
      syncUsaSsh: false,
      syncCargando: false,
      syncMostrarCred: false,
      syncGuardandoCred: false,
      syncImportando: false,
      syncLimpiando: false,
      syncResultado: null,
      syncTablas: [],
      syncSeleccionadas: [],
      syncCred: {
        host: '127.0.0.1', port: '3306', database: '', username: '', password: '',
        ssh_host: '', ssh_user: 'root', ssh_port: '22', ssh_key: '/home/quantydev/.ssh/id_prod',
        usar_ssh: false,
      },
      // Logs de producción
      logsMostrar: false,
      logsProdUrl: process.env.VUE_APP_LOGS_PROD_URL || '',
      logsProdToken: process.env.VUE_APP_LOGS_PROD_TOKEN || '',
      logsCargando: false,
      logsCargandoContenido: false,
      logsArchivos: [],
      logsArchivoActual: null,
      logsContenido: null,
      logsTotalLineas: null,
      logsGuardando: false,
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    esDev() { return process.env.NODE_ENV === 'development'; },
    syncTotalFaltantes() {
      return this.syncTablas.reduce((acc, t) => acc + (t.faltantes || 0), 0);
    },
  },
  methods: {
    async handleConfiguracion() {
      this.loading = true;
      try {
        const resp = await this.$store.dispatch("auth/guardaConfiguracion", this.user);
        this.loading = false;
        if (resp && resp.res === 'OK') {
          showSwal.methods.showSwal({ type: "success", message: "Configuración guardada correctamente", width: 600 });
        } else {
          showSwal.methods.showSwal({ type: "error", message: resp?.mensaje || "Error al guardar configuración", width: 500 });
        }
      } catch (error) {
        this.loading = false;
        showSwal.methods.showSwal({ type: "error", message: "Se ha producido un error inesperado", width: 500 });
      }
    },

    irInicio() { this.$router.push('/dashboard'); },

    async lanzarValidacion() {
      this.lanzadaValidacion = true;
      this.loadingValidacion = true;
      try {
        const resp = await this.$store.dispatch("auth/lanzaValidacionMovil", this.user);
        if (resp.res == 'OK') {
          showSwal.methods.showSwal({ type: "success", message: "Proceso de validación finalizado", width: 600 });
        } else {
          showSwal.methods.showSwal({ type: "error", message: resp.mensaje, width: 500 });
        }
      } catch (error) {
        showSwal.methods.showSwal({ type: "error", message: "Se ha producido un error al lanzar la validación", width: 500 });
      } finally {
        this.loadingValidacion = false;
        await this.cargarConfiguracion();
      }
    },

    async confirmarReset() {
      const resultado = await showSwal.methods.showConfirm({
        title: '¿Reiniciar configuración?',
        message: 'Se eliminarán todos los parámetros de configuración y la sesión TDLib del móvil. Tendrás que volver a introducir todos los datos.',
        type: 'warning',
        confirmButtonText: 'Sí, reiniciar',
        cancelButtonText: 'Cancelar',
      });
      if (!resultado.isConfirmed) return;

      this.loadingReset = true;
      try {
        const resp = await this.$store.dispatch("auth/resetSistema");
        if (resp?.res === 'OK') {
          showSwal.methods.showSwal({ type: "success", message: "Sistema reiniciado correctamente", width: 500 });
          await this.cargarConfiguracion();
          this.lanzadaValidacion = false;
        } else {
          showSwal.methods.showSwal({ type: "error", message: resp?.mensaje || "Error al reiniciar", width: 500 });
        }
      } catch (error) {
        showSwal.methods.showSwal({ type: "error", message: "Error inesperado al reiniciar", width: 500 });
      } finally {
        this.loadingReset = false;
      }
    },

    async generarBackup() {
      this.loadingBackup = true;
      try {
        const response = await this.$store.dispatch("auth/backupBd");
        const fecha = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        const hora = new Date().toTimeString().slice(0, 8).replace(/:/g, '');
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `backup_${fecha}_${hora}.sql`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        showSwal.methods.showSwal({ type: "success", message: "Backup generado y descargado correctamente", width: 500 });
      } catch (error) {
        showSwal.methods.showSwal({ type: "error", message: "Error al generar el backup", width: 450 });
      } finally {
        this.loadingBackup = false;
      }
    },

    async cargarEstadoSync() {
      this.syncCargando = true;
      try {
        const res = await this.$store.dispatch("auth/syncProdEstado");
        if (res?.ok === false && res?.mensaje?.includes('producción')) {
          // El backend indicó explícitamente que estamos en producción
          this.syncDisponible = false;
          return;
        }
        this.syncDisponible = true;
        this.syncConectado  = res?.conectado || false;
        this.syncUsaSsh     = res?.usa_ssh || false;
        this.syncTablas     = res?.tablas || [];
        if (res?.configurado && !res?.conectado) {
          this.syncMostrarCred = true;
        }
        if (res?.usa_ssh) {
          this.syncCred.usar_ssh = true;
        }
      } catch (e) {
        // Solo ocultar la sección si el backend devuelve 403 explícitamente
        const status = e?.response?.status;
        if (status === 403) {
          this.syncDisponible = false;
        } else {
          // Cualquier otro error: mostrar la sección con estado de error
          this.syncDisponible = true;
          this.syncConectado = false;
          this.syncMostrarCred = true;
          console.warn('[SyncProd] Error al cargar estado:', e?.message || e);
        }
      } finally {
        this.syncCargando = false;
      }
    },

    async probarConfigGtm() {
      this.gtmProbando = true;
      this.gtmResultado = null;
      try {
        const apiBase = process.env.VUE_APP_API_BASE_URL || '';
        const res = await fetch(`${apiBase}/api/v2/public/app-config`);
        const cfg = await res.json();
        const partes = [];
        if (cfg.gtm_id) partes.push(`GTM: ${cfg.gtm_id}`);
        if (cfg.ga4_id) partes.push(`GA4: ${cfg.ga4_id}`);
        if (partes.length) {
          this.gtmResultado = { ok: true, msg: '✓ ' + partes.join(' · ') };
        } else {
          this.gtmResultado = { ok: false, msg: '⚠ No hay IDs configurados aún' };
        }
      } catch (e) {
        this.gtmResultado = { ok: false, msg: '✗ Error al conectar con el endpoint' };
      } finally {
        this.gtmProbando = false;
      }
    },

    async guardarCredencialesProd() {
      this.syncGuardandoCred = true;
      try {
        const payload = {
          prod_db_host:     this.syncCred.host,
          prod_db_port:     this.syncCred.port,
          prod_db_database: this.syncCred.database,
          prod_db_username: this.syncCred.username,
          prod_db_password: this.syncCred.password,
          // SSH: enviar vacío para limpiar si no se usa túnel
          prod_ssh_host: this.syncCred.usar_ssh ? this.syncCred.ssh_host : '',
          prod_ssh_user: this.syncCred.usar_ssh ? this.syncCred.ssh_user : '',
          prod_ssh_port: this.syncCred.usar_ssh ? this.syncCred.ssh_port : '',
          prod_ssh_key:  this.syncCred.usar_ssh ? this.syncCred.ssh_key  : '',
        };
        const res = await this.$store.dispatch("auth/syncProdCredenciales", payload);
        if (res.ok) {
          showSwal.methods.showSwal({ type: "success", message: "Conexión correcta. Cargando tablas...", width: 500 });
          this.syncMostrarCred = false;
          await this.cargarEstadoSync();
        } else {
          showSwal.methods.showSwal({ type: "error", message: res.mensaje || "Error al conectar", width: 500 });
        }
      } catch {
        showSwal.methods.showSwal({ type: "error", message: "Error inesperado al guardar credenciales", width: 500 });
      } finally {
        this.syncGuardandoCred = false;
      }
    },

    syncSeleccionarTodas() {
      this.syncSeleccionadas = this.syncTablas
        .filter(t => t.has_id && !t.error && t.faltantes > 0)
        .map(t => t.tabla);
    },

    async importarDesdeProd() {
      if (!this.syncSeleccionadas.length) return;
      const resultado = await showSwal.methods.showConfirm({
        title: '¿Importar datos desde producción?',
        message: `Se importarán filas nuevas de ${this.syncSeleccionadas.length} tabla(s). Los datos existentes en dev no se tocan.`,
        type: 'warning',
        confirmButtonText: 'Sí, importar',
        cancelButtonText: 'Cancelar',
      });
      if (!resultado.isConfirmed) return;

      this.syncImportando = true;
      this.syncResultado  = null;
      try {
        const res = await this.$store.dispatch("auth/syncProdImportar", this.syncSeleccionadas);
        if (res.ok) {
          this.syncResultado = res;
          showSwal.methods.showSwal({ type: "success", message: `Importación completada. ${res.total_insertados} filas insertadas.`, width: 500 });
          await this.cargarEstadoSync();
        } else {
          showSwal.methods.showSwal({ type: "error", message: res.mensaje || "Error al importar", width: 500 });
        }
      } catch {
        showSwal.methods.showSwal({ type: "error", message: "Error inesperado durante la importación", width: 500 });
      } finally {
        this.syncImportando = false;
      }
    },

    async limpiarDesarrollo() {
      const resultado = await showSwal.methods.showConfirm({
        title: '⚠️ Limpiar base de datos de desarrollo',
        message: 'Se hará un backup de dev, se BORRARÁN todos los datos (excepto usuarios, roles y configuración) y se recargará la BD completa desde producción. ¿Continuar?',
        type: 'warning',
        confirmButtonText: 'Sí, limpiar y recargar',
        cancelButtonText: 'Cancelar',
      });
      if (!resultado.isConfirmed) return;

      this.syncLimpiando = true;
      this.syncResultado = null;
      try {
        const res = await this.$store.dispatch("auth/syncProdLimpiar");
        if (res.ok) {
          const kb = Math.round((res.backup_size || 0) / 1024);
          showSwal.methods.showSwal({
            type: "success",
            message: `BD recargada desde prod. ${res.tablas_ok} tablas · ${res.total_filas} filas. Backup: ${res.backup_file} (${kb} KB)`,
            width: 600,
          });
          await this.cargarEstadoSync();
        } else {
          showSwal.methods.showSwal({ type: "error", message: res.mensaje || "Error al limpiar", width: 500 });
        }
      } catch {
        showSwal.methods.showSwal({ type: "error", message: "Error inesperado durante la limpieza", width: 500 });
      } finally {
        this.syncLimpiando = false;
      }
    },

    async cargarConfiguracion() {
      try {
        const response = await this.$store.dispatch("auth/configuracion", {});
        if (response.data.length > 0) {
          for (let row of response.data) {
            if (row.nombre === 'bot') this.user.bot = row.valor;
            if (row.nombre === 'tokenBot') this.user.tokenBot = row.valor;
            if (row.nombre === 'apiId') this.user.apiId = row.valor;
            if (row.nombre === 'apiHash') this.user.apiHash = row.valor;
            if (row.nombre === 'mostrarCanales') this.user.mostrarCanales = row.valor == 1;
            if (row.nombre === 'rastreoTelegram') this.rastreoTelegram = row.valor;
            if (row.nombre === 'movilQuanty') this.user.movilQuanty = row.valor;
            if (row.nombre === 'codeQuanty') this.user.codeQuanty = row.valor;
            if (row.nombre === 'validadoQuanty') {
              this.user.validadoQuanty = row.valor == 1;
              if (this.user.validadoQuanty) this.lanzadaValidacion = true;
            }
            const integraciones = [
              'stripe_secret_key', 'stripe_webhook_secret', 'comision_porcentaje', 'openai_api_key',
              'telegram_bot_premium_token',
              'mail_host', 'mail_port', 'mail_username', 'mail_password',
              'mail_encryption', 'mail_from_address', 'mail_from_name', 'mail_contact_to',
              'meta_pixel_id', 'meta_app_id', 'meta_ad_account_id', 'meta_test_event_code',
              'meta_capi_token', 'meta_marketing_token',
              'gtm_id', 'ga4_id', 'ga4_api_secret',
            ];
            if (integraciones.includes(row.nombre)) this.user[row.nombre] = row.valor || '';
            if (row.nombre === 'stripe_payment_element_enabled') {
              this.user.stripe_payment_element_enabled = row.valor == 1;
            }
          }
        }
      } catch (error) {
        console.error('Error al cargar configuración:', error);
      }
    },

    // ── Logs de producción ────────────────────────────────────────────
    async logsCargarLista() {
      this.logsCargando = true;
      this.logsArchivos = [];
      this.logsArchivoActual = null;
      this.logsContenido = null;
      try {
        const res = await this.$store.dispatch("auth/logsProxy", {
          url_prod: this.logsProdUrl,
          token_prod: this.logsProdToken,
        });
        if (!res?.ok) throw new Error(res?.mensaje || "Error");
        this.logsArchivos = res.archivos || [];
        // Persistir credenciales en localStorage para comodidad
        try {
          localStorage.setItem('logs_prod_url', this.logsProdUrl);
          localStorage.setItem('logs_prod_token', this.logsProdToken);
        } catch (err) { /* localStorage no disponible */ void err; }
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: e.message || "Error conectando con prod", width: 500 });
      } finally {
        this.logsCargando = false;
      }
    },
    async logsVerArchivo(archivo) {
      this.logsCargandoContenido = true;
      this.logsArchivoActual = archivo;
      this.logsContenido = null;
      this.logsTotalLineas = null;
      try {
        const res = await this.$store.dispatch("auth/logsProxy", {
          url_prod: this.logsProdUrl,
          token_prod: this.logsProdToken,
          archivo,
        });
        if (!res?.ok) throw new Error(res?.mensaje || "Error");
        this.logsContenido = res.contenido || "";
        this.logsTotalLineas = res.total_lin || null;
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: e.message || "Error cargando log", width: 500 });
        this.logsArchivoActual = null;
      } finally {
        this.logsCargandoContenido = false;
      }
    },

    async logsGuardarLocal() {
      if (!this.logsArchivoActual || !this.logsContenido) return;
      this.logsGuardando = true;
      try {
        const res = await this.$store.dispatch("auth/logsGuardar", {
          archivo: this.logsArchivoActual,
          contenido: this.logsContenido,
        });
        if (res?.ok) {
          showSwal.methods.showSwal({ type: "success", message: `Guardado en ${res.ruta}`, width: 500 });
        }
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: e.message || "Error al guardar", width: 450 });
      } finally {
        this.logsGuardando = false;
      }
    },
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    await this.cargarConfiguracion();
    // Intentar siempre — el backend devuelve 403 si no es superadmin o si es producción
    this.cargarEstadoSync();
    // Recuperar credenciales de logs guardadas en localStorage
    try {
      this.logsProdUrl   = localStorage.getItem('logs_prod_url')   || process.env.VUE_APP_LOGS_PROD_URL   || '';
      this.logsProdToken = localStorage.getItem('logs_prod_token') || process.env.VUE_APP_LOGS_PROD_TOKEN || '';
    } catch (err) { /* localStorage no disponible */ void err; }
  },
};
</script>

<style scoped>
/* ── Page header ── */
.cfg-page-header {
  padding: 0.25rem 0;
}
.cfg-page-title {
  font-family: var(--q-font-display);
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--q-text);
  margin: 0 0 0.25rem;
}
.cfg-page-sub {
  font-size: 0.82rem;
  color: var(--q-muted);
  margin: 0;
}

/* ── Section card ── */
.cfg-section {
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: var(--q-radius);
  margin-bottom: 1rem;
  overflow: hidden;
}
.cfg-section--last {
  margin-bottom: 0;
}

/* ── Section header ── */
.cfg-section-hd {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1rem 1.25rem;
  background: var(--q-card-alt);
  border-bottom: 1px solid var(--q-border-md);
}
.cfg-icon {
  font-size: 1.4rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 0.1rem;
}
.cfg-section-title {
  font-family: var(--q-font-display);
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--q-text);
  margin: 0 0 0.2rem;
  letter-spacing: 0.01em;
}
.cfg-section-desc {
  font-size: 0.78rem;
  color: var(--q-muted);
  margin: 0;
  line-height: 1.4;
}

/* ── Section body ── */
.cfg-section-bd {
  padding: 1.25rem 1.25rem 1.5rem;
}

/* ── Fields: label-izquierda / input-derecha ── */
:deep(.label-input > div) {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 0.5rem;
}
:deep(.label-input .form-label) {
  flex-shrink: 0;
  white-space: nowrap;
  margin: 0 !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  color: var(--q-muted) !important;
}
:deep(.label-input .form-control) {
  flex: 1 1 60px;
  min-width: 0;
}
:deep(.label-input .error-feedback) {
  flex: 0 0 100%;
  order: 3;
}

/* ── Helper text ── */
.cfg-hint {
  font-size: 0.72rem;
  color: var(--q-muted);
  margin-top: 0.3rem;
  display: block;
}

/* ── Toggle rows ── */
.cfg-toggle-row {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
}
.cfg-toggle-label {
  font-size: 0.83rem;
  color: var(--q-text);
  line-height: 1.5;
}

/* ── Info/status row ── */
.cfg-info-row {
  display: flex;
  align-items: center;
  font-size: 0.82rem;
  color: var(--q-muted);
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 6px;
  padding: 0.55rem 0.85rem;
}

/* ── Tools section ── */
.cfg-section--tools .cfg-section-bd {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: space-between;
}
.cfg-tool-label {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--q-text);
  margin: 0 0 0.25rem;
}
.cfg-tool-desc {
  font-size: 0.78rem;
  color: var(--q-muted);
  margin: 0;
  max-width: 500px;
  line-height: 1.45;
}

/* ── Actions bar ── */
.cfg-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding-bottom: 2rem;
}
.cfg-btn {
  min-width: 180px;
}
@media (max-width: 480px) {
  .cfg-btn { width: 100%; min-width: unset; }
  .cfg-actions { flex-direction: column-reverse; }
}

/* ── Sección sync prod ─────────────────────────────────── */
.cfg-section--sync .cfg-section-hd { align-items: center; }

.sync-dev-badge {
  margin-left: auto;
  flex-shrink: 0;
  background: #f59e0b22;
  color: #f59e0b;
  border: 1px solid #f59e0b55;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .5px;
  padding: 3px 8px;
  border-radius: 4px;
}

/* Credenciales */
.sync-cred-block {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1.25rem;
}
.sync-cred-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.7rem 1rem;
  cursor: pointer;
  user-select: none;
}
.sync-cred-header:hover { background: var(--q-hover); }
.sync-cred-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--q-text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.sync-cred-toggle { font-size: 11px; color: var(--q-muted); }
.sync-cred-form {
  padding: 1rem;
  border-top: 1px solid var(--q-border);
}

.sync-icon-ok   { color: var(--q-green); }
.sync-icon-warn { color: #f59e0b; }

.sync-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--q-muted);
  margin-bottom: 3px;
}
.sync-input {
  width: 100%;
  background: var(--q-card);
  border: 1px solid var(--q-border-md);
  border-radius: 6px;
  color: var(--q-text);
  padding: 7px 10px;
  font-size: 13px;
  outline: none;
}
.sync-input:focus { border-color: var(--q-gold); }

/* Buttons */
.sync-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  outline: none;
  transition: opacity .15s;
}
.sync-btn:disabled { opacity: .45; cursor: not-allowed; }
.sync-btn--primary {
  background: var(--q-gold);
  color: var(--q-gold-on);
}
.sync-btn--primary:hover:not(:disabled) { background: var(--q-gold-hover); }
.sync-btn--ghost {
  background: none;
  border: 1px solid var(--q-border-md);
  color: var(--q-text);
}
.sync-btn--ghost:hover:not(:disabled) { border-color: var(--q-gold); }
.sync-btn--import {
  background: var(--q-green);
  color: #fff;
}
.sync-btn--import:hover:not(:disabled) { opacity: .88; }
.sync-btn--limpiar {
  background: var(--q-red, #ef4444);
  color: #fff;
}
.sync-btn--limpiar:hover:not(:disabled) { opacity: .88; }

.badge-ok {
  font-size: .78rem;
  color: #84cc16;
  background: rgba(132,204,22,.12);
  border: 1px solid rgba(132,204,22,.3);
  border-radius: 6px;
  padding: 4px 10px;
}
.badge-err {
  font-size: .78rem;
  color: #f87171;
  background: rgba(248,113,113,.12);
  border: 1px solid rgba(248,113,113,.3);
  border-radius: 6px;
  padding: 4px 10px;
}

/* Toolbar */
.sync-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 0.75rem;
}
.sync-table-info { font-size: 12px; color: var(--q-muted); font-weight: 600; }
.sync-table-actions { display: flex; gap: 6px; flex-wrap: wrap; }

/* Tabla de comparación */
.sync-table-wrap { overflow-x: auto; border: 1px solid var(--q-border-md); border-radius: 8px; margin-bottom: 1rem; }
.sync-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.sync-table--sm { font-size: 12px; }
.sync-th {
  padding: 8px 12px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: .4px;
  color: var(--q-muted);
  border-bottom: 1px solid var(--q-border-md);
  white-space: nowrap;
}
.sync-th--check { width: 36px; text-align: center; }
.sync-th--name  { text-align: left; }
.sync-th--num   { text-align: right; }
.sync-tr { border-bottom: 1px solid var(--q-border); }
.sync-tr:last-child { border-bottom: none; }
.sync-tr--sel { background: var(--q-hover); }
.sync-tr--err { opacity: .6; }
.sync-td { padding: 7px 12px; color: var(--q-text); white-space: nowrap; }
.sync-td--check { text-align: center; }
.sync-td--name  { text-align: left; font-family: var(--q-font-mono, monospace); font-size: 12px; }
.sync-td--num   { text-align: right; font-variant-numeric: tabular-nums; color: var(--q-muted); }
.sync-check { cursor: pointer; accent-color: var(--q-gold); width: 14px; height: 14px; }

.sync-badge-new  { background: #10b98122; color: var(--q-green); border: 1px solid #10b98155; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px; }
.sync-badge-ok   { background: var(--q-border); color: var(--q-muted); font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 4px; }
.sync-badge-err  { background: #ef444422; color: var(--q-red, #ef4444); border: 1px solid #ef444455; font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 4px; }
.sync-badge-info { background: var(--q-border); color: var(--q-muted); font-size: 10px; padding: 2px 6px; border-radius: 4px; margin-left: 4px; }

/* Barra de importar */
.sync-import-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}
.sync-sel-info { font-size: 12px; color: var(--q-muted); }

/* Resultado */
.sync-resultado {
  margin-top: 1.25rem;
  background: var(--q-card-alt);
  border: 1px solid var(--q-border-md);
  border-radius: 8px;
  padding: 1rem;
}
.sync-resultado-titulo {
  font-size: 13px;
  font-weight: 700;
  color: var(--q-text);
  margin: 0 0 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.sync-resultado-tabla-wrap { overflow-x: auto; border-radius: 6px; border: 1px solid var(--q-border); }

/* SSH toggle y pasos */
.sync-ssh-toggle { display: flex; align-items: center; gap: 8px; }
.sync-ssh-toggle-label { display: flex; align-items: center; gap: 8px; font-size: 13px; font-weight: 600; color: var(--q-text); cursor: pointer; user-select: none; }
.sync-ssh-hint {
  font-size: 12px;
  color: var(--q-muted);
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 6px;
  padding: 8px 12px;
  margin-bottom: 0.75rem;
  line-height: 1.5;
}
.sync-ssh-steps {
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-left: 3px solid var(--q-gold);
  border-radius: 6px;
  padding: 10px 14px;
}
.sync-ssh-steps-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; color: var(--q-muted); margin: 0 0 6px; }
.sync-ssh-pre {
  font-family: var(--q-font-mono, monospace);
  font-size: 12px;
  color: var(--q-text);
  background: none;
  margin: 0;
  padding: 0;
  white-space: pre-wrap;
  word-break: break-all;
}
.sync-sep { border: none; border-top: 1px solid var(--q-border); }

/* ── Logs de producción ── */
.logs-prod-block { border-top: 1px solid var(--q-border); padding-top: 16px; }
.logs-viewer-header {
  display: flex; align-items: baseline; gap: 12px; flex-wrap: wrap;
  margin-bottom: 8px;
}
.logs-viewer-titulo { font-weight: 700; font-size: 13px; color: var(--q-gold, #ffd700); }
.logs-viewer-meta { font-size: 11px; color: var(--q-muted); }
.logs-viewer-wrap {
  max-height: 500px; overflow-y: auto; overflow-x: auto;
  background: #0d1520; border: 1px solid var(--q-border-md);
  border-radius: 8px; padding: 12px;
}
.logs-viewer-pre {
  font-family: 'Fira Mono', 'Consolas', 'Menlo', monospace;
  font-size: 11px; line-height: 1.6;
  color: #c8d3e0; margin: 0; white-space: pre-wrap; word-break: break-all;
}

@media (max-width: 600px) {
  .sync-table-toolbar { flex-direction: column; align-items: flex-start; }
  .sync-import-bar { flex-direction: column; align-items: flex-start; }
  .logs-viewer-wrap { max-height: 300px; }
}
</style>
